<template>
  <div class="page">
    <div class="help-list">
      <div class="help-item" v-for="(item,index) in helpList" :key="index">
        <div :class="{'item-index':true,'tea-index':isTea}">{{ index + 1 }}.</div>
        <div>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {isCottiApp} from "@/utils";

export default {
  name: "help",
  computed: {
    isTea() {
      return window.location.host.includes('teacat');
    }
  },
  data() {
    return {
      helpList: [
        '您可通过「我的」-「发票管理」或「订单」-「去开票」提交开票申请；',
        '发票由您下单的门店经营主体 (开票主体) 为您开具；',
        '各种形式的优惠券、折扣等促销活动抵扣的金额不支持开票。使用了代金券的订单，以代金券实付金额开票；',
        '如购买方为企业的，除发票抬头填写全称外，还需提供准确的纳税人识别号或统一社会信用代码，以免影响无法正常报销；',
        '您应遵照国家税收相关法律法规的要求，正确填写发票抬头和其他信息，如填写信息不合规，则我们将保留对发票进行冲红的权利，同时可能应政府有关部门要求提供您的违规情况；',
        '如您错填发票抬头信息需要进行修改，请联系在线客服处理；',
        '如无法自助操作或有其他问题，请联系在线客服处理。'
      ],
    };
  },
  methods: {
    test() {
      isCottiApp()
      console.log('test');
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  background-color: #F5F6F7;
  height: 100%;
  padding: 24px 40px 0 40px;
}

.help-item {
  display: flex;
  flex-direction: row;
  padding-top: 16px;

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #3A3B3C;
  line-height: 48px;
  text-align: left;
  font-style: normal;
}

.item-index {
  color: #A52337;
  width: 135px;
  max-width: 34px;
}

.tea-index {
  color: #FF8000;
}

</style>
